import type { AtlasViewport } from "@/components/ecv2/components/whiteboardEC/schema/canvas/canvasTypes";

export const ATLAS_MIN_ZOOM = 0.05;
export const ATLAS_MAX_ZOOM = 20;
export const ATLAS_DEFAULT_VIEWPORT: AtlasViewport = Object.freeze({ x: 0, y: 0, zoom: 1 });

function isFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function isCanonicalAtlasViewport(value: unknown): value is AtlasViewport {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return false;
  }
  const viewport = value as Record<string, unknown>;
  return (
    isFiniteNumber(viewport.x) &&
    isFiniteNumber(viewport.y) &&
    isFiniteNumber(viewport.zoom) &&
    viewport.zoom >= ATLAS_MIN_ZOOM &&
    viewport.zoom <= ATLAS_MAX_ZOOM
  );
}

export function normalizeAtlasViewport(value: unknown): AtlasViewport {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return { ...ATLAS_DEFAULT_VIEWPORT };
  }
  const viewport = value as Record<string, unknown>;
  if (
    !isFiniteNumber(viewport.x) ||
    !isFiniteNumber(viewport.y) ||
    !isFiniteNumber(viewport.zoom) ||
    viewport.zoom <= 0
  ) {
    return { ...ATLAS_DEFAULT_VIEWPORT };
  }
  if (isCanonicalAtlasViewport(value)) {
    return value;
  }
  return {
    x: viewport.x,
    y: viewport.y,
    zoom: Math.min(ATLAS_MAX_ZOOM, Math.max(ATLAS_MIN_ZOOM, viewport.zoom)),
  };
}
